import React from 'react'
import styles from '../AdminPanelPage.module.scss'

const AllDriversPanel = ({
  drivers,
  driversPagination,
  driversFilter,
  setDriversFilter,
  loadDriversPage,
  blockDriver,
  unblockDriver,
  topBases,
  chpps,
  privatePoints
}) => {
  
  const getBaseName = (driver) => {
    // Бэкенд уже возвращает top_base_name, который содержит имя любой базы
    return driver.top_base_name || '-'
  }

  const handleAction = async (driver) => {
    if (driver.status === 'Заблокирован') {
      await unblockDriver(driver.id)
    } else {
      await blockDriver(driver.id)
    }
  }

  return (
    <div className={styles.panel}>
      <div className={styles.panelHeader}>
        <div className={styles.panelTitle}>Окно: Все водители</div>
      </div>
      <div className={styles.panelBody}>
        <div className={styles.searchRow}>
          <input 
            className={styles.searchInput} 
            placeholder="Поиск по водителю, номеру машины, базе..." 
            value={driversFilter} 
            onChange={(e) => setDriversFilter(e.target.value)} 
            onKeyDown={(e) => { if (e.key === 'Enter') loadDriversPage(1, driversFilter) }} 
          />
        </div>
        {drivers && drivers.length ? (
          <table className={styles.table}>
            <thead>
              <tr>
                <th>№</th>
                <th>Водитель</th>
                <th>Номер машины</th>
                <th>Марка</th>
                <th>База</th>
                <th>Номер телефона</th>
                <th>Количество поездок</th>
                <th>Статус</th>
                <th>Статус машины</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {drivers.map((driver, index) => (
                <tr key={driver.id}>
                  <td>{index + 1}</td>
                  <td>{driver.employee_name  || '-'}</td>
                  <td>{driver.vehicle_number || '-'}</td>
                  <td>{driver.vehicle_model || '-'}</td>
                  <td>{getBaseName(driver)}</td>
                  <td>{driver.employee_phone || driver.phone || '-'}</td>
                  <td>
                    <strong style={{ color: '#0d6efd', fontSize: '15px' }}>
                      {driver.loads_count || 0}
                    </strong>
                  </td>
                  <td>
                    <span style={{ 
                      color: driver.is_active ? '#198754' : '#dc3545',
                      fontWeight: 600 
                    }}>
                      {driver.is_active ? 'Активен' : 'Неактивен'}
                    </span>
                  </td>
                  <td>
                    <span style={{ 
                      color: driver.status === 'Заблокирован' ? '#dc3545' : 
                             driver.status === 'В пути' ? '#ffc107' : '#198754',
                      fontWeight: 600 
                    }}>
                      {driver.status || 'Свободен'}
                    </span>
                  </td>
                  <td>
                    {['Активен', 'В пути', 'Свободен', 'Заблокирован'].includes(driver.status) || !driver.status ? (
                      <button 
                        className={styles.smallBtn}
                        style={{
                          background: driver.status === 'Заблокирован' ? '#198754' : '#dc3545'
                        }}
                        onClick={() => handleAction(driver)}
                      >
                        {driver.status === 'Заблокирован' ? 'Разблокировать' : 'Заблокировать'}
                      </button>
                    ) : (
                      <span style={{ color: '#6c757d' }}>—</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div>Водители не найдены</div>
        )}
        {(!driversFilter && driversPagination && driversPagination.count > 0) && (
          <div className={styles.pagination}>
            <button disabled={!driversPagination.previous} onClick={() => loadDriversPage((driversPagination.page || 1) - 1)}>Пред.</button>
            <span>Стр. {driversPagination.page || 1} — Всего: {driversPagination.count}</span>
            <button disabled={!driversPagination.next} onClick={() => loadDriversPage((driversPagination.page || 1) + 1)}>След.</button>
          </div>
        )}
      </div>
    </div>
  )
}

export default AllDriversPanel
